/* @flow */
import React, { PropTypes } from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Autosuggest from 'react-autosuggest';

class FaqAutosuggest extends React.Component {

  static propTypes = {
    faqs: PropTypes.array,
    showFaqItem: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.state = {
      value: '',
      suggestions: []
    };

    this.getSuggestions = this.getSuggestions.bind(this);
    this.handleSuggestionsFetchRequested = this.handleSuggestionsFetchRequested.bind(this);
    this.handleSuggestionsClearRequested = this.handleSuggestionsClearRequested.bind(this);
    this.handleSuggestionSelected = this.handleSuggestionSelected.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  getSuggestions (value) {
    const query = value.trim();

    if (!query.length) {
      return [];
    }

    let suggestions = [];

    this.props.faqs.forEach(faq => {
      const matches = faq.questionGroup.filter(group => {
        let question = group.q.toLowerCase();
        let answer = group.a.toLowerCase();
        let qa = `${question} ${answer}`;
        return qa.indexOf(query.toLowerCase()) > -1;
      });
      suggestions = suggestions.concat(matches);
    });

    return suggestions.length ? suggestions : [{q: proxyCounterpart('NO_RESULTS_FOUND')}];
  }

  renderSuggestion (suggestion) {
    let answer = suggestion.a
      ? suggestion.a
        .replace(/(<([^>]+)>)/ig, '') // Replace html
        .replace(/&#8211;/g, '') // Replace all - characters
      : '';
    let qa = `${suggestion.q} - ${answer}`;
    return `${qa.substring(0, 80)}...`;
  }

  shouldRenderSuggestions (value) {
    return value.trim().length > 1;
  }

  getSuggestionValue (suggestion) {
    return suggestion.q;
  }

  handleSuggestionsFetchRequested ({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  }

  handleSuggestionsClearRequested () {
    this.setState({
      suggestions: []
    });
  }

  handleSuggestionSelected (event, { suggestion, suggestionValue }) {
    this.props.showFaqItem(suggestion);
  }

  handleChange (event, { newValue }) {
    this.setState({
      value: newValue
    });
  }

  render () {
    const { value, suggestions } = this.state;

    const inputProps = {
      value,
      onChange: this.handleChange,
      placeholder: proxyCounterpart('SEARCH_FAQ')
    };

    return (
      <div className="search-wrapper">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
          onSuggestionSelected={this.handleSuggestionSelected}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          shouldRenderSuggestions={this.shouldRenderSuggestions}
          inputProps={inputProps}
        />
        <button className="search" type="submit"><div></div></button>
      </div>
    );
  }
}

export default FaqAutosuggest;



/** WEBPACK FOOTER **
 ** ./src/views/faq/faq-autosuggest.js
 **/